import { useMemo } from 'react';

import Ad from 'components/landing/Ad';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import css from 'styles/components/hf/6pm/footerAds.scss';

// This will have 2 rows. Row 1 has 3 cols. Row 2 has 1 col going the full width.
// See my shitty drawing: https://github01.zappos.net/storage/user/388/files/248e2a00-a03c-11ea-834f-69b58d2facec

const filteredAdsInit = { topLeft: [], topCenter: [], topRight: [], bottom: [] };
const adPositions = {
  'top-left': 'topLeft',
  'top-center': 'topCenter',
  'top-right': 'topRight',
  'bottom': 'bottom'
};

export const FooterAds = ({ ad = {} }) => {
  const { componentName, ad: ads = [] } = ad;

  const { topLeft, topCenter, topRight, bottom } = useMemo(() =>
    ads.reduce((acc, ad) => {
      const mappedValue = adPositions[ad.position];
      return mappedValue ? { ...acc, [mappedValue]: [ ...acc[mappedValue], ad ] } : acc;
    }, filteredAdsInit)
  , [ads]);

  if (componentName !== 'ad') {
    return null;
  }

  return (
    <div className={css.container}>
      <div className={css.topLeft}>
        <Ad containerClassOverride={css.adContainerOverride} ads={topLeft}/>
      </div>
      <div className={css.topCenter}>
        <Ad containerClassOverride={css.adContainerOverride} ads={topCenter}/>
      </div>
      <div className={css.topRight}>
        <Ad containerClassOverride={css.adContainerOverride} ads={topRight}/>
      </div>
      <div className={css.bottom}>
        <Ad containerClassOverride={css.adContainerOverride} ads={bottom}/>
      </div>
    </div>
  );
};

export default withErrorBoundary('FooterAds', FooterAds);
